import React, { useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as pabReplanningAction from '../../../../../actions/pabReplanningAction';
import HomeDefault from '../../../../../components/HomeDefaultComponent';
import PABReplanningService from '../../../../../services/PABReplanningService';
import RoutePickingService from '../../../../../services/RoutePickingService';
import { checkPermission } from '../../../../../services/auth';
import { ENUMS, PERMISSIONS } from '../../../../../utils/constants';
import { gerarCSV, translate } from '../../../../../utils/util';

const SmallPartsFilter = (props) => {
    useEffect(() => {
        props.resetFilter();
        props.resetOrdesAll();
        // eslint-disable-next-line
    }, [])

    const menuSmallPartsFilter = () => {
        let menuItems = [];

        menuItems = [
            ...menuItems,
            {
                route: {
                    pathname: 'filter/supplier',
                    state: {
                        name: null,
                        icon: null,
                        label: null,
                        required: null,
                        orderType: ENUMS.eOrderType.PabReplanning.value,
                        route: 'filter/supplier',
                        title: { icon: "mdi mdi-camera-timer", label: translate('menu:pabReplanning') },
                        subtitle: { icon: "mdi mdi-filter-variant", label: translate('expedition:picking.filterBySupplier') }
                    }
                },
                icon: 'filter_center_focus',
                text: translate('expedition:picking.supplier')
            }
        ];
        menuItems = [...menuItems, {
            route:
            {
                pathname: 'filter/partnumber',
            }, icon: 'layers', text: translate('line-picking:linepicking.partnumber')
        }];

        menuItems = [...menuItems, {
            route: {
                pathname: 'orders'
            },
            icon: 'mdi mdi-view-list',
            text: translate('expedition:picking.all'),
            onClick: () => {
                props.setFilterOrder(props.filter);
            }
        }];

        if (checkPermission(PERMISSIONS.PABReplanning.ManagePabReplanning)) {

            if (navigator.userAgent !== 'logisticspwa') {
                menuItems = [...menuItems, {
                    icon: 'mdi mdi-clipboard-list-outline',
                    text: translate('line-picking:linepicking.open-calls'),
                    route: 'filter',
                    onClick: () => {
                        props.getOrderOpen((response) => {
                            gerarCSV(translate('line-picking:linepicking.calls'), response);
                            props.history.go(-1);
                        });
                    }
                }];
            }
        }

        return menuItems;
    };

    return (
        <HomeDefault menu={menuSmallPartsFilter()} subtitles={[{ icon: "mdi mdi-filter-variant", label: translate('line-picking:linepicking.filter') }]} />
    );
};

export const mapStateToProps = (state) => {
    return {
        filter: state.pabReplanningReducer.filter,
        almox: state.pabReplanningReducer.almox,
        areas: state.pabReplanningReducer.areas,
    };
};

export const mapDispatchToProps = (dispatch) => {
    return {
        resetFilter: () => {
            dispatch(pabReplanningAction.resetFilter());
        },
        resetOrdesAll: () => {
            dispatch(pabReplanningAction.resetOrdesAll());
        },
        setFilterOrder: (filter) => {
            dispatch(pabReplanningAction.setFilter(filter));
        },
        getRoutes: (filter, callback) => {
            dispatch(RoutePickingService.getRoutes(filter, callback));
        },
        getOrderOpen: (callback) => {
            dispatch(PABReplanningService.getOrdersOpen(callback));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SmallPartsFilter)));
